"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _generateRandomString = _interopRequireDefault(require("../../utils/generateRandomString"));

var _pkceChallengeFromVerifier = _interopRequireDefault(require("../../utils/pkceChallengeFromVerifier"));

var _settingsResolver = _interopRequireDefault(require("../../settingsResolver"));

var buildAuthenticationRequest = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(baseSettings, callbackUrl) {
    var state,
        codeVerifier,
        codeChallenge,
        settings,
        params,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _args.length > 2 && _args[2] !== undefined ? _args[2] : '';
            // Create and store a new PKCE code_verifier (the plaintext random secret)
            codeVerifier = (0, _generateRandomString.default)();
            localStorage.setItem('pkce_code_verifier', codeVerifier); // Hash and base64-urlencode the secret to use as the challenge

            _context.next = 5;
            return (0, _pkceChallengeFromVerifier.default)(codeVerifier);

          case 5:
            codeChallenge = _context.sent;
            _context.next = 8;
            return (0, _settingsResolver.default)(baseSettings);

          case 8:
            settings = _context.sent;
            params = new URLSearchParams({
              response_type: 'code',
              client_id: settings.clientId,
              scope: settings.scope,
              redirect_uri: "".concat(window.location.origin).concat(callbackUrl),
              code_challenge: codeChallenge,
              code_challenge_method: 'S256'
            });

            if (state) {
              params.append('state', state);
            } // Build the authorization URL


            return _context.abrupt("return", "".concat(settings.authorize, "?").concat(params.toString()));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function buildAuthenticationRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = buildAuthenticationRequest;
exports.default = _default;